// Unpublished Work © 2023-2026 Deere & Company.

export const processEnvSvc = (key) => {
    const localhost = {
        FEATURE_TOGGLES: {
            'ADD_TO_CONTEXT_BUTTON_FOR_BUSINESS': true,
            'ADD_TO_CONTEXT_BUTTON_FOR_INSTALLMENT_BUSINESS': true,
            'DCTP_126_MAINTAIN_CONTACTS': true,
            'F10324_US159746_SHOW_ORG_ID_FACET': true,
            'F10734_US58064_CITY_DROPDOWN_ADD_EDIT_PAGE': true,
            'F10879_US59461_GET_ALL_PRIVACY_POLICIES_FROM_API': true,
            'F11649_REGISTRY_ADMIN_USER_DETAILS': true,
            'F11849_DISPLAY_LOG_HISTORY': true,
            'F6469_US62845_PREFERRED_LANGUAGE_SELECT': true,
            'F6893_US151310_DOOB_FLOW_UPON_ADDING_A_CUSTOMER': true,
            'F6897_US174681_CUSTOMER_DATA_SHARE_WITH_DBS': true,
            'F6897_US181841_SHOW_COUNTY_ON_DATA_SHARE': false,
            'FILL_ADD_CUSTOMER_FROM_FACETS': true,
            'INSERT_WALKME_SCRIPT': false,
            'SHOW_CITY_DROPDOWN_FACET': true,
            'SHOW_TAX_ID_FACET': true,
            '_TEST_FEATURE_OFF': false,
            '_TEST_FEATURE_ON': true,
            'NON_JDF_FLOW_BUT_HAVE_JDF_MEMBERSHIP': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'VERIFIED_USER_ICON_FOR_LEGALLY_VERIFIED_CUSTOMER': true,
            'JDF_REGISTRANT_NUMBERS': true,
            'JDF_MOBILE_PHONE_NUMBER_REQUIRED': true,
            'BUSINESS_CONTACT_ACTIONS_DROPDOWN': true,
            'DISPLAY_DIGITAL_USER_ACCOUNT': true,
            'DBS_LINKAGE_SEARCH_FILTER': true
        },
        WALKME_SCRIPT: 'https://cdn.walkme.com/users/bcc878543d254ef3862010b45686232a/test/walkme_bcc878543d254ef3862010b45686232a_https.js',
        BYPASS_OKTA: true,
        OKTA_ISSUER: 'https://sso-dev.johndeere.com/oauth2/ausgnh0431ebF8iiL0h7',
        OKTA_CLIENT_ID: '0oay3ih9t6j4GNYWS0h7',
        HELPDESK_URL: 'https://johndeere.service-now.com/ep',
        SERVICE_NOW: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        DELETE_BUSINESS_CONTACT_SERVICE_NOW_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=600',
        MARKETING_PREFERENCES_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        FEEDBACK_SERVICE_NOW_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=1600',
        CUSTOMER_LINKAGE_URL: 'https://customerlinkagequal.tal.deere.com/'
    };

    const qual = {
        API_URL: 'https://dealer-customer-tools-servicesqual.deere.com/isg/customerservices',
        OKTA_CLIENT_ID: '0oavgd7iqbxoMXFIZ0h7',
        OKTA_ISSUER: 'https://sso-qual.johndeere.com/oauth2/ausi42oq38DYB06q50h7',
        DELETE_BUSINESS_CONTACT_SERVICE_NOW_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=600',
        SERVICE_NOW: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        MARKETING_PREFERENCES_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        HELPDESK_URL: 'https://johndeere.service-now.com/ep',
        FEEDBACK_SERVICE_NOW_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=1600',
        BYPASS_OKTA: false,
        WALKME_SCRIPT: 'https://cdn.walkme.com/users/bcc878543d254ef3862010b45686232a/test/walkme_bcc878543d254ef3862010b45686232a_https.js',
        CUSTOMER_LINKAGE_URL: 'https://customerlinkagequal.tal.deere.com/',
        FEATURE_TOGGLES: {
            'ADD_TO_CONTEXT_BUTTON_FOR_BUSINESS': true,
            'ADD_TO_CONTEXT_BUTTON_FOR_INSTALLMENT_BUSINESS': true,
            'DCTP_126_MAINTAIN_CONTACTS': true,
            'F10324_US159746_SHOW_ORG_ID_FACET': true,
            'F10734_US58064_CITY_DROPDOWN_ADD_EDIT_PAGE': true,
            'F10879_US59461_GET_ALL_PRIVACY_POLICIES_FROM_API': true,
            'F11649_REGISTRY_ADMIN_USER_DETAILS': true,
            'F11849_DISPLAY_LOG_HISTORY': true,
            'F6469_US62845_PREFERRED_LANGUAGE_SELECT': true,
            'F6893_US151310_DOOB_FLOW_UPON_ADDING_A_CUSTOMER': true,
            'F6897_US174681_CUSTOMER_DATA_SHARE_WITH_DBS': true,
            'F6897_US181841_SHOW_COUNTY_ON_DATA_SHARE': false,
            'FILL_ADD_CUSTOMER_FROM_FACETS': true,
            'INSERT_WALKME_SCRIPT': true,
            'SHOW_CITY_DROPDOWN_FACET': true,
            'SHOW_TAX_ID_FACET': true,
            'NON_JDF_FLOW_BUT_HAVE_JDF_MEMBERSHIP': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'VERIFIED_USER_ICON_FOR_LEGALLY_VERIFIED_CUSTOMER': true,
            'JDF_REGISTRANT_NUMBERS': true,
            'JDF_MOBILE_PHONE_NUMBER_REQUIRED': true,
            'BUSINESS_CONTACT_ACTIONS_DROPDOWN': true,
            'DISPLAY_DIGITAL_USER_ACCOUNT': true,
            'DBS_LINKAGE_SEARCH_FILTER': true
        }
    };

    const cert = {
        FEATURE_TOGGLES: {
            'ADD_TO_CONTEXT_BUTTON_FOR_BUSINESS': true,
            'ADD_TO_CONTEXT_BUTTON_FOR_INSTALLMENT_BUSINESS': true,
            'DCTP_126_MAINTAIN_CONTACTS': false,
            'F10324_US159746_SHOW_ORG_ID_FACET': true,
            'F10734_US58064_CITY_DROPDOWN_ADD_EDIT_PAGE': true,
            'F10879_US59461_GET_ALL_PRIVACY_POLICIES_FROM_API': true,
            'F11649_REGISTRY_ADMIN_USER_DETAILS': true,
            'F11849_DISPLAY_LOG_HISTORY': true,
            'F6469_US62845_PREFERRED_LANGUAGE_SELECT': true,
            'F6893_US151310_DOOB_FLOW_UPON_ADDING_A_CUSTOMER': true,
            'F6897_US174681_CUSTOMER_DATA_SHARE_WITH_DBS': true,
            'F6897_US181841_SHOW_COUNTY_ON_DATA_SHARE': false,
            'FILL_ADD_CUSTOMER_FROM_FACETS': true,
            'INSERT_WALKME_SCRIPT': true,
            'SHOW_CITY_DROPDOWN_FACET': true,
            'SHOW_TAX_ID_FACET': true,
            'NON_JDF_FLOW_BUT_HAVE_JDF_MEMBERSHIP': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'VERIFIED_USER_ICON_FOR_LEGALLY_VERIFIED_CUSTOMER': true,
            'JDF_REGISTRANT_NUMBERS': true,
            'JDF_MOBILE_PHONE_NUMBER_REQUIRED': true,
            'BUSINESS_CONTACT_ACTIONS_DROPDOWN': true,
            'DISPLAY_DIGITAL_USER_ACCOUNT': true,
            'DBS_LINKAGE_SEARCH_FILTER': true
        },
        API_URL: 'https://dealer-customer-tools-servicescert.deere.com/isg/customerservices',
        OKTA_CLIENT_ID: '0oagcnba05H712Asj1t7',
        OKTA_ISSUER: 'https://sso-cert.johndeere.com/oauth2/aus97etlxsNTFzHT11t7',
        DELETE_BUSINESS_CONTACT_SERVICE_NOW_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=600',
        WALKME_SCRIPT: 'https://cdn.walkme.com/users/bcc878543d254ef3862010b45686232a/test/walkme_bcc878543d254ef3862010b45686232a_https.js',
        BYPASS_OKTA: false,
        SERVICE_NOW: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        MARKETING_PREFERENCES_URL: 'https://johndeerepreprod.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        HELPDESK_URL: 'https://johndeere.service-now.com/ep',
        FEEDBACK_SERVICE_NOW_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=1600',
        CUSTOMER_LINKAGE_URL: 'https://customerlinkage.cert.deere.com/'
    };

    const prod = {
        API_URL: 'https://dealer-customer-tools-servicesprod.deere.com/isg/customerservices',
        OKTA_CLIENT_ID: '0oaie06ltjQiWD8yR1t7',
        OKTA_ISSUER: 'https://sso.johndeere.com/oauth2/aus9k0fb8kUjG8S5Z1t7',
        DELETE_BUSINESS_CONTACT_SERVICE_NOW_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=600',
        SERVICE_NOW: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        MARKETING_PREFERENCES_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a',
        HELPDESK_URL: 'https://johndeere.service-now.com/ep',
        FEEDBACK_SERVICE_NOW_URL: 'https://johndeere.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=6eed19081b0d4010f0f643fccd4bcb3a&sysparm_dataissue=1600',
        BYPASS_OKTA: false,
        WALKME_SCRIPT: 'https://cdn.walkme.com/users/bcc878543d254ef3862010b45686232a/walkme_bcc878543d254ef3862010b45686232a_https.js',
        CUSTOMER_LINKAGE_URL: 'https://customerlinkage.deere.com/',
        FEATURE_TOGGLES: {
            'ADD_TO_CONTEXT_BUTTON_FOR_BUSINESS': true,
            'ADD_TO_CONTEXT_BUTTON_FOR_INSTALLMENT_BUSINESS': true,
            'DCTP_126_MAINTAIN_CONTACTS': false,
            'F10324_US159746_SHOW_ORG_ID_FACET': true,
            'F10734_US58064_CITY_DROPDOWN_ADD_EDIT_PAGE': true,
            'F10879_US59461_GET_ALL_PRIVACY_POLICIES_FROM_API': true,
            'F11649_REGISTRY_ADMIN_USER_DETAILS': true,
            'F11849_DISPLAY_LOG_HISTORY': true,
            'F6469_US62845_PREFERRED_LANGUAGE_SELECT': true,
            'F6893_US151310_DOOB_FLOW_UPON_ADDING_A_CUSTOMER': true,
            'F6897_US174681_CUSTOMER_DATA_SHARE_WITH_DBS': true,
            'F6897_US181841_SHOW_COUNTY_ON_DATA_SHARE': false,
            'FILL_ADD_CUSTOMER_FROM_FACETS': true,
            'INSERT_WALKME_SCRIPT': true,
            'SHOW_CITY_DROPDOWN_FACET': true,
            'SHOW_TAX_ID_FACET': true,
            'NON_JDF_FLOW_BUT_HAVE_JDF_MEMBERSHIP': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS': true,
            'NON_JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'JDF_FLOW_READ_ONLY_NAME_DETAILS_FOR_DOOB': true,
            'VERIFIED_USER_ICON_FOR_LEGALLY_VERIFIED_CUSTOMER': true,
            'JDF_REGISTRANT_NUMBERS': true,
            'JDF_MOBILE_PHONE_NUMBER_REQUIRED': true,
            'BUSINESS_CONTACT_ACTIONS_DROPDOWN': true,
            'DISPLAY_DIGITAL_USER_ACCOUNT': true,
            'DBS_LINKAGE_SEARCH_FILTER': false
        }
    };

    const hostname = globalThis.location.hostname;

    const hostnameAlias = {
        'localhost': 'localhost',
        'customersearchqual.tal.deere.com': 'qual',
        'customersearchcert.deere.com': 'cert',
        'customersearch.deere.com': 'prod'
    };

    const environment = hostnameAlias[hostname];

    const environments = {
        localhost,
        qual,
        cert,
        prod
    };

    return environments[environment][key];
};
